import type { CastMember } from "@/mocks/titles";

export default function CastList({ cast }: { cast: CastMember[] }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
      {cast.map((member) => (
        <div key={member.name} className="bg-background-100 rounded-lg p-3 md:p-4">
          <div className="w-full aspect-square rounded-md overflow-hidden bg-background-200 mb-3">
            <img
              src={member.avatar}
              alt={`${member.name} 演职人员照片`}
              title={`${member.name} 星光传媒演职人员`}
              className="w-full h-full object-cover object-top grayscale-[15%] hover:grayscale-0 transition-all duration-500"
            />
          </div>
          <p className="text-sm text-foreground-950 font-medium truncate">{member.name}</p>
          <p className="text-[11px] md:text-xs text-foreground-500 mt-1 line-clamp-2">{member.role}</p>
        </div>
      ))}
    </div>
  );
}